import React from 'react';
import { Stack, styled } from '@mui/material';
import { Controller } from 'react-hook-form';

import { HeaderClient } from '../../elements/HeaderClient';
import { ButtonCustom } from 'app/components/elements/ButtonCustom';
import { InputText } from 'app/components/elements/InputText';
import { AddFloorPlan } from 'app/components/elements/AddFloorPlan';

import { useInjection } from './hook';

export const UpdateFloorPlan = () => {
  const {
    backToClient,
    handleSubmit,
    asyncupdateFloorPlan,
    uploadfloorplan,
    errors,
    control,
    paths,
    floorplanurl,
    floorplanfile
  } = useInjection();

  return (
    <WrapperUpdatePage>
      <HeaderClient
        paths={paths}
        searchholder=""
        onClickButton={backToClient}
        textButton="Cancel"
        title={'Update Floor Plan'}
      />

      <Stack flexDirection="row" justifyContent="space-between" alignItems="center">
        <Stack width="100%" maxWidth="532px" gap={3}>
          <Controller
            name="value"
            control={control}
            render={({ field }) => (
              <InputText
                title="Location Name"
                placeholder="Name"
                inputError={errors.value?.message}
                inputProps={{ ...field, value: field.value ?? '' }}
              />
            )}
          />

          <Controller
            name="floorPlan"
            control={control}
            render={({ field }) => (
              <AddFloorPlan
                label="Floor Plan"
                url={floorplanurl}
                value={field.value ?? floorplanfile}
                errorText={errors.floorPlan?.message}
                onChange={async (selectedFile) => {
                  if (!selectedFile) {
                    field.onChange(null);
                    return;
                  }

                  try {
                    const processedFile = await uploadfloorplan(selectedFile);
                    field.onChange(processedFile ?? null);
                  } catch (error) {
                    console.error('Floor plan processing failed:', error);
                    field.onChange(null);
                  }
                }}
                onRemove={() => field.onChange(null)}
              />
            )}
          />

          <ButtonCustom
            label="Update"
            style={{ width: '370px' }}
            onClick={handleSubmit(asyncupdateFloorPlan, (errors) => console.log(errors))}
          />
        </Stack>
      </Stack>
    </WrapperUpdatePage>
  );
};

const WrapperUpdatePage = styled(Stack)(() => ({
  padding: '40px 30px 50px 40px',
  width: '100%'
}));
